<template>
  <VView class="home">
    <VBlock max-width="111px">
      <img src="@/assets/stars.png" />
    </VBlock>

    <hr />

    <VText center big>
      Pokaż nam jak spędzasz czas<br />
      z Przyjaciółmi na Comedy Central
    </VText>

    <hr />

    <VBlock max-width="976px">
      <img src="@/assets/home-prizes.png" />
    </VBlock>

    <VText center big>
      Uwolnij kreatywność<br />
      i walcz o serialowe gadzety!
    </VText>

    <VBlock max-width="460px">
      <transition name="bounceUp" appear>
        <VButton to="/menu">{{ $t('home.button') }}</VButton>
      </transition>
    </VBlock>
  </VView>
</template>

<script>
export default {
  name: 'Home',
};
</script>

<style lang="scss" scoped>
.home {}
</style>
